import _ from 'lodash';

import { handleCommonErrors } from 'scripts/application/lib/gateway_error_silent_handler';
import qconsole from 'scripts/lib/qconsole';
import TaskEmail from 'models/task_email';
import TaskInfo from 'models/task_info';

export default class FetchTaskThread {
  constructor(context) {
    this.context = context;
  }

  run({ taskId }) {
    if (!taskId) {
      throw new Error('FetchTaskThread must be called with a task id');
    }

    const taskInfoStore = this.context.stores.taskInfo;
    let taskInfo = taskInfoStore.findBy({ id: taskId });
    if (!taskInfo) taskInfo = TaskInfo.create({ id: taskId });
    taskInfo.setEmailsLoading();
    taskInfoStore.addOrReplace(taskInfo);

    // A plain GET: the thread has no broadcast topic of its own. New children arrive on the customer's
    // topic and refetch through customer_history_gateway_observer, and a reconnect replays the
    // history request, which reaches here again for every task, so nothing is left stale.
    // This runs for every task in a fetched history, so failures are reported silently, not toasted.
    this.context.gateways.taskThread
      .fetchAll({ taskId })
      .then(threadDto => {
        // don't `.set` because that would blow away other emails
        let taskInfo = taskInfoStore.findBy({ id: taskId });
        // The task can leave the store while the fetch is in flight (the agent navigates away).
        if (!taskInfo) return;

        taskInfo.setThread({ channel: threadDto.channel, counterpart: threadDto.counterpart });
        _.forEach(threadDto.items, item => {
          if (item.email) taskInfo.addEmail(TaskEmail.fromThreadItem(item));
        });
        taskInfoStore.addOrReplace(taskInfo);
      })
      .catch(err => {
        qconsole.error(`Unable to fetch the thread for task [${taskId}]`);
        handleCommonErrors(this.context, err);
      })
      .finally(() => {
        let taskInfo = taskInfoStore.findBy({ id: taskId });
        if (!taskInfo) return;

        taskInfo.resetEmailsLoading();
        taskInfoStore.addOrReplace(taskInfo);
      });
  }
}
